import React from 'react';
import { __WEB__ } from '../../constants/styles';

export default function DivWebOnly(props) {
  if (__WEB__) return <div className={props.className}>{props.children}</div>;
  return <>{props.children}</>;
}
